import { call, put } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import Axios from "../../utils/axios";
import { ACCOUNT_FORGOT_PASSWORD } from "../../state/user/constants";
import { LOGIN } from "../../constants";
import {
  requestPasswordResetDone,
  requestPasswordResetError
} from "../../state/user/actions";
import { showErrorSnackbar } from "../../utils/util";

function* requestPasswordReset({
  payload: { email, username, history, location, shortName }
}) {
  try {
    const result = yield call(Axios.core.post, ACCOUNT_FORGOT_PASSWORD, {
      email: email || username
    });

    yield put(requestPasswordResetDone());
    if (result?.data) {
      const { success, message } = result.data;
      if (success) {
        toastr.clean();
        toastr.success("", message, {
          timeOut: 5000
        });
        history.push(`/${shortName}/${LOGIN}${location.search}`);
      } else {
        showErrorSnackbar(message, {
          removeOnHover: false
        });
      }
    }
  } catch (e) {
    const errorMessage = JSON.parse(e.request.response).message;
    showErrorSnackbar(errorMessage, {
      removeOnHover: false
    });
    yield put(requestPasswordResetError(e));
  }
}

export default requestPasswordReset;
